import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SidePanelComponent } from './components/side-panel/side-panel.component'
import { FileDropZoneDirective } from './directives/file-drop-zone.directive'
import { MultiSelectBoxComponent } from './components/multi-select-box/multi-select-box.component'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { GenericConfirmationDialogComponent } from './components/generic-confirmation-dialog/generic-confirmation-dialog.component'
import { DefaultToastComponent } from './components/default-toast/default-toast.component'
import { FileSizePipe } from './pipes/file-size.pipe'
import { PercentagePipe } from './pipes/percentage.pipe'
import { TopBarComponent } from './components/top-bar/top-bar.component'
import { LogoutComponent } from './components/top-bar/logout/logout.component'
import { ViewerZoomControlsComponent } from './components/top-bar/viewer-zoom-controls/viewer-zoom-controls.component'
import { ViewerCoordinateControlsComponent } from './components/top-bar/viewer-coordinate-controls/viewer-coordinate-controls.component'
import { GenericSingleInputDialogComponent } from './components/generic-single-input-dialog/generic-single-input-dialog.component'
import { FormsModule } from '@angular/forms'
import { LetDirective } from '@ngrx/component'
import { RouterModule } from '@angular/router'
import { SnapshotCanvasComponent } from './components/top-bar/snapshot-canvas/snapshot-canvas.component'

@NgModule({
    declarations: [
        SidePanelComponent,
        FileDropZoneDirective,
        MultiSelectBoxComponent,
        GenericConfirmationDialogComponent,
        DefaultToastComponent,
        FileSizePipe,
        PercentagePipe,
        TopBarComponent,
        LogoutComponent,
        ViewerZoomControlsComponent,
        ViewerCoordinateControlsComponent,
        GenericSingleInputDialogComponent,
    ],
    imports: [
        CommonModule,
        UiLibraryModule,
        FormsModule,
        LetDirective,
        RouterModule,
        SnapshotCanvasComponent,
    ],
    exports: [
        SidePanelComponent,
        FileDropZoneDirective,
        MultiSelectBoxComponent,
        GenericConfirmationDialogComponent,
        FileSizePipe,
        PercentagePipe,
        TopBarComponent,
    ],
})
export class SharedModule {}
